import React, { useEffect, useState, useContext } from "react";
import axios from 'axios';
import DataSnapshots from "components/Private/BaolinEventsAnalytics/FifteenAnniversary/DataSnapshots";
import ChartsContext from "../../contexts/ChartsContext";

// react-bootstrap components
import {
  Container,
} from "react-bootstrap";
import InsightCharts from "components/Private/BaolinEventsAnalytics/FifteenAnniversary/InsightCharts";

function BaolinDashboard() {
  const { setChartsData, setUpdateTime, checkin3R5P } = useContext(ChartsContext);
  const fetchEventStatistics = () => {
    axios.get(`${process.env.REACT_APP_SERVER_URL}/event/geteventstatistics?event=lianghuang`)
      .then(response => {
        const currentTime = new Date().toLocaleString();
        setUpdateTime(currentTime);
        setChartsData(response.data);
        console.log(response.data);
        console.log(checkin3R5P);
        // fetch3R5PStatistics()
      })
      .catch(error => {
        console.error("Error fetching event statistics:", error);
      });
  };

  useEffect(() => {
    fetchEventStatistics(); // Initial data fetch
  }, []);
  return (
    <>
      <Container fluid>
        <DataSnapshots onRefresh={fetchEventStatistics} />
        <InsightCharts onRefresh={fetchEventStatistics} />
      </Container>
    </>

  );
}

export default BaolinDashboard;
